import {
  AppAction,
  Application
} from '../apis/eols-app-link/eols-app-link.constants';
import { AppLinkRedirectErrorMessage } from '../pages/app-link-redirect/app-link-redirect.constants';
import { AssessmentTypeDto } from '../apis/eols-assessment-service/eols-assessment-service.dtos';

export enum AnalyticsAction {
  LOGIN_LAUNCH = 'LOGIN_LAUNCH',
  APP_LINK_LAUNCH = 'APP_LINK_LAUNCH',
  APP_LINK_ERROR = 'APP_LINK_ERROR',
  APP_LINK_OUT = 'APP_LINK_OUT',
  CREATE_A_QUIZ_CLICK = 'CREATE_A_QUIZ_CLICK',
  RESUME_QUIZ_CLICK = 'RESUME_QUIZ_CLICK',
  VIEW_RESULTS_CLICK = 'VIEW_RESULTS_CLICK',
  QUIZ_ME_ON_THIS_TOPIC_CLICK = 'QUIZ_ME_ON_THIS_TOPIC_CLICK',
  EAQ_REPORT_CONTENT_ERROR_CLICKED = 'EAQ_REPORT_CONTENT_ERROR_CLICKED',
  API_ERROR = 'API_ERROR',
  OSMOSIS_VIDEO_PLAYER_EVENT = 'OSMOSIS_VIDEO_PLAYER_EVENT',
  JS_ERROR = 'JS_ERROR',
  JS_ERROR_PAGE_REFRESH = 'JS_ERROR_PAGE_REFRESH',
  AI_CHAT_LAUNCH_REDIRECTED = 'AI_CHAT_LAUNCH_REDIRECTED',
}

export enum AnalyticsRef {
  SIDEBAR = 'SIDEBAR',
  SYLLABUS = 'SYLLABUS',
  BATCH_ACTION_BAR = 'BATCH_ACTION_BAR',
}

export enum AnalyticsFilterType {
  EBOOK_FILTER = 'EBOOK_FILTER',
  STATUS_FILTER = 'STATUS_FILTER',
  TYPE_FILTER = 'TYPE_FILTER',
  GRADING_FILTER = 'GRADING_FILTER',
  HESI_FOCUS_CHAPTER = 'HESI_FOCUS_CHAPTER',
}

export type AnalyticsActionProps = {
  action: AnalyticsAction.LOGIN_LAUNCH;
  props: null;
} | {
  action: AnalyticsAction.API_ERROR;
  props: {
    status: string;
    action: string;
    url: string;
    method: string;
  };
} | {
  action: AnalyticsAction.APP_LINK_ERROR;
  props: {
    type: AppLinkRedirectErrorMessage;
    status: string;
    url: string;
    method: string;
  };
} | {
  action: AnalyticsAction.APP_LINK_OUT
    | AnalyticsAction.APP_LINK_LAUNCH;
  props: {
    linkType: AppAction;
    srcApp: Application;
    targetApp: Application;
  };
} | {
  action: AnalyticsAction.CREATE_A_QUIZ_CLICK;
  props: {};
} | {
  action: AnalyticsAction.OSMOSIS_VIDEO_PLAYER_EVENT;
  props: {
    type: string;
    activeChatId: string;
    videoId: string;
  };
} | {
  action: AnalyticsAction.QUIZ_ME_ON_THIS_TOPIC_CLICK;
  props: {
    assessmentTopicVtwId: string;
    selectedIsbn: string;
  };
} | {
  action: AnalyticsAction.RESUME_QUIZ_CLICK | AnalyticsAction.VIEW_RESULTS_CLICK;
  props: {
    assessmentId: number;
    assessmentType: AssessmentTypeDto;
    assessmentGoal: number;
    assessmentTopicVtwIds: string[];
  };
} | {
  action: AnalyticsAction.EAQ_REPORT_CONTENT_ERROR_CLICKED;
  props: {
    assessmentId: number;
    assessmentType: AssessmentTypeDto;
    questionVtwId: string;
    questionType: string;
    isbn: string;
  };
} | {
  action: AnalyticsAction.JS_ERROR;
  props: {
    errorName: string;
    errorMessage: string;
    errorStack: string;
  };
} | {
  action: AnalyticsAction.AI_CHAT_LAUNCH_REDIRECTED;
  props: {
    ref: string;
  };
} | {
  action: AnalyticsAction.JS_ERROR_PAGE_REFRESH;
  props: null;
};
